import { render, staticRenderFns } from "./JgpText.vue?vue&type=template&id=55375c53&"
import script from "./JgpText.vue?vue&type=script&lang=js&"
export * from "./JgpText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports